/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationTagsProvidersSurveyData
 */
export interface FxIdApplicationTagsProvidersSurveyData {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationTagsProvidersSurveyData
     */
    Show: boolean;
}

/**
 * Check if a given object implements the FxIdApplicationTagsProvidersSurveyData interface.
 */
export function instanceOfFxIdApplicationTagsProvidersSurveyData(value: object): value is FxIdApplicationTagsProvidersSurveyData {
    if (!('Show' in value) || value['Show'] === undefined) return false;
    return true;
}

export function FxIdApplicationTagsProvidersSurveyDataFromJSON(json: any): FxIdApplicationTagsProvidersSurveyData {
    return FxIdApplicationTagsProvidersSurveyDataFromJSONTyped(json, false);
}

export function FxIdApplicationTagsProvidersSurveyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationTagsProvidersSurveyData {
    if (json == null) {
        return json;
    }
    return {
        
        'Show': json['show'],
    };
}

export function FxIdApplicationTagsProvidersSurveyDataToJSON(json: any): FxIdApplicationTagsProvidersSurveyData {
    return FxIdApplicationTagsProvidersSurveyDataToJSONTyped(json, false);
}

export function FxIdApplicationTagsProvidersSurveyDataToJSONTyped(value?: FxIdApplicationTagsProvidersSurveyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'show': value['Show'],
    };
}

